import request from './adminRequest'

export const ossApi = {
  listOssLargeFile (params) {
    return request.get('/ossLargeFile', { params: params })
  },
}
export default ossApi
